export default __webpack_public_path__ + "static/assets/fbab79667a258440d762eb0e80f9a24b.png";